import { Box } from "@mui/material";
import React, { useMemo } from "react";
import { object } from "prop-types";
import { SubsidiaryDropdownAutoSave } from "@/features";
import { useUser } from "@/app/providers";
import { useGetGroups } from "@/hooks";
import type { SxProps, Theme } from "@mui/material/styles";

type SubsidiarySelectorProps = {
  sx?: SxProps<Theme>;
};

/**
 *
 */
export const SubsidiarySelector = (props: SubsidiarySelectorProps) => {
  const { user } = useUser();
  const { currentTeamId } = user || {};
  const { subsidiary } = useGetGroups({
    customerId: currentTeamId,
  });

  const boxSx = useMemo(() => {
    return {
      ...props.sx,
      ml: 2,
    };
  }, [props.sx]);

  return (
    <Box sx={boxSx}>
      {subsidiary?.length > 0 && <SubsidiaryDropdownAutoSave />}
    </Box>
  );
};
SubsidiarySelector.propTypes = {
  sx: object,
};
